import React from 'react';
import PayViaLinkSuccessResult from '@/features/payment/presentation/components/PayViaLinkSuccessResult';

export const PayViaLinkSuccessPage: React.FC = () => {
  return <PayViaLinkSuccessResult />;
};

export default PayViaLinkSuccessPage;
